export default __webpack_public_path__ + "static/media/logo.a37fba72.jpg";